import React, { useEffect, useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

import { useUnidades } from "../../../hooks/test/useUnidades";
import Swal from "sweetalert2";
import { SocketContext } from "../../../context/SocketContext";
import { Spinner } from "react-bootstrap";
import { AuthContext } from "../../../context/authContext/authContext";

export const FormularioBitacora = ({
  viaje_id,
  negocioId,
  getBitacora = async () => {},
  close = null,
  estateLoading,
  onSuccess,          // <- renombrado para claridad
}) => {
  const { getListaEstatus, postBitacora } = useUnidades();
  const [listaEstatus, setListaEstatus] = useState([]);
  const [loading, setLoading] = useState(false); // controla localmente
  const { socket } = useContext(SocketContext);
  const { user } = useContext(AuthContext);

  const [form, setForm] = useState({
    status_id: "",
    descripcion: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const saveForm = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const resp = await postBitacora({
        id_viaje: viaje_id,
        notas: form.descripcion,
        id_status: form.status_id,
      });

      if (!resp?.ok) {
        Swal.fire({
          title: "No se pudo guardar la bitácora",
          text: resp?.msg || "",
          icon: "error",
        });
        return;
      }

      Swal.fire({
        title: "Bitácora actualizada con éxito",
        text: resp?.msg || "Se agregó a bitácora",
        icon: "success",
      });

      // Refresca la bitácora y ESPERA a que termine
      let ok = false;
      try {
        ok = await getBitacora(); // debe devolver true/false
      } catch (e) {
        ok = false;
      }

      // Emitir sockets
      if (user.roles_id === 2) {
        socket.emit("traer-unidades-en-ruta_", { idNegocio: parseInt(negocioId) });
        socket.emit("bitacora_dinamica", { idNegocio: parseInt(negocioId) });
      } else {
        socket.emit("bitacora_dinamica", { idNegocio: user.negocio_id });
        socket.emit("traer-unidades-en-ruta_", { idNegocio: user.negocio_id });
      }

      clearForm();

      // ✅ Notificar al padre que todo terminó bien
      if (ok && typeof onSuccess === "function") {
        onSuccess(); // aquí el padre hará setIsChange(true)
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      const resp = await getListaEstatus();
      if (resp?.ok) setListaEstatus(resp.estatus);
      setLoading(false);
    })();
  }, []);

  const clearForm = () => {
    setForm({ status_id: "", descripcion: "" });
  };

  const { status_id, descripcion } = form;

  return (
    <>
      <form className="form-group" onSubmit={saveForm}>
        <div className="row">
          <select
            className="form-control control-input selectCedis"
            value={status_id}
            name="status_id"
            onChange={handleChange}
            required
          >
            <option value="">SELECCIONA ESTATUS</option>
            {listaEstatus.map((elemento) => (
              <option
                value={`${elemento.status_id}`}
                key={elemento.status_id}
                disabled={elemento.cancel === 1}
              >
                {elemento.nombre}
              </option>
            ))}
          </select>
        </div>
        <br />
        <div className="row">
          <textarea
            className="form-control"
            placeholder="Observaciones o comentarios"
            value={descripcion}
            name="descripcion"
            onChange={handleChange}
            style={{ fontSize: "18px" }}
          />
        </div>
        <br />
        <button className="btn btn-warning btn-block" disabled={estateLoading || loading}>
          {loading ? (
            <>
              <Spinner size="sm" /> Enviando....
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faPaperPlane} /> Enviar evento
            </>
          )}
        </button>
      </form>
    </>
  );
};
